// import { v4 as uuid } from "uuid";

/**
 * Category Database can be added here.
 * You can add category of your wish with different attributes
 * */

export const categories = [
  {
    _id: "abc001",
    categoryName: "Hollywood",
    image: "https://ik.imagekit.io/qsdtqu5hp/cinemate-images/holly.png?updatedAt=1684226202741",
    description:
      "Get the latest blockbusters and cult classics from Hollywood.",
  },
  {
    _id: "abc002",
    categoryName: "Bollywood",
    image: "https://ik.imagekit.io/qsdtqu5hp/cinemate-images/bolly.png?updatedAt=1684226202789",
    description:
      "Bollywood movies that will make you dance to their tunes.",
  },
  {
    _id: "abc003",
    categoryName: "Regional",
    image: "https://ik.imagekit.io/qsdtqu5hp/cinemate-images/regional_films.png?updatedAt=1684226202735",
    description:
      "Embrace the diversity of regional cinema with our curated collection.",
  },

  {
    _id: "abc004",
    categoryName: "World",
    image: "https://ik.imagekit.io/qsdtqu5hp/cinemate-images/world_cinema.png?updatedAt=1684226202481",
    description:
      "Expand your horizons with the best of world cinema, now within your reach",
  },
];
